import ModalCreateMaterialConnect from '../../../../../../../../app/erp/screens/Logistic/MaterialsParent/Materials/ModalCreateMaterial'
import ModalCreateAddonConnect from '../../../../../../../../app/erp/screens/Logistic/ProductsParent/Addons/ModalCreateAddon'
import ModalCreatePackagingConnect from '../../../../../../../../app/erp/screens/Logistic/ProductsParent/Packagings/ModalCreatePackaging'
import ModalCreateProductConnect from '../../../../../../../../app/erp/screens/Logistic/ProductsParent/Products/ModalCreateProduct'
import ModalCreateServiceConnect from '../../../../../../../../app/erp/screens/Logistic/ProductsParent/Services/ModalCreateService'
import locations from '../../../../../../../../utils/globals/locations'
import { ModalEditComponentProps } from '../../../../../../../ModalsLayouts/types'

interface ProductCreateModalShortcutProps extends ModalEditComponentProps {}

export const ProductCreateModalShortcut: React.FC<ProductCreateModalShortcutProps> = ({...rest }) => {
    return (<ModalCreateProductConnect {...rest} customLocation={locations.product} />)
}

interface PackagingCreateModalShortcutProps extends ModalEditComponentProps {}

export const PackagingCreateModalShortcut: React.FC<PackagingCreateModalShortcutProps> = ({...rest}) => {
    return (<ModalCreatePackagingConnect {...rest} customLocation={locations.packaging}/>)
}

interface AddonCreateModalShortcutProps extends ModalEditComponentProps {}

export const AddonCreateModalShortcut: React.FC<AddonCreateModalShortcutProps> = ({...rest}) => {
    return (<ModalCreateAddonConnect {...rest} customLocation={locations.addon}/>)
}

interface MaterialCreateModalShortcutProps extends ModalEditComponentProps {}

export const MaterialCreateModalShortcut: React.FC<MaterialCreateModalShortcutProps> = ({...rest}) => {
    return (<ModalCreateMaterialConnect  {...rest} customLocation={locations.material}/>)
}

interface ServiceCreateModalShortcutProps extends ModalEditComponentProps {}

export const ServiceCreateModalShortcut: React.FC<ServiceCreateModalShortcutProps> = ({...rest}) => {
    return (<ModalCreateServiceConnect  {...rest} customLocation={locations.services} />)
}

